<template>
  <LottieAnimation
    v-if="isAnimatingFish"
    :animation-data="jumpingFishAnimationData"
    :auto-play="true"
    :loop="true"
    class="jumping-fish"
    :speed="1"
    @loopComplete="completeFishAnimation"
    ref="anim"
  />
</template>

<script>
import LottieAnimation from "lottie-web-vue";
import { mapActions, mapGetters } from "vuex";
export default {
  components: { LottieAnimation },
  computed: {
    ...mapGetters("eastereggs", ["isAnimatingFish", "jumpingFishAnimationData"]),
  },
  methods: {
    ...mapActions("eastereggs", ["completeFishAnimation"]),
  },
};
</script>

<style scoped lang="scss">
.jumping-fish {
  position: absolute;
  top: 0;
  right: 0;
  transform: translateY(-100%);
  height: 200px;
  width: 200px;
  z-index: 800;
}
</style>
